import * as v from 'valibot';
import { TimestampSchema } from './common';
// =============================================================================
// Inbox Schemas
// =============================================================================
export const InboxListRequestSchema = v.object({
    since: v.optional(v.number()),
});
export const InboxListResponseSchema = v.object({
    messages: v.array(v.object({
        id: v.string(),
        identity_id: v.string(),
        received_at: TimestampSchema,
        expires_at: TimestampSchema,
        meta_v: v.number(),
        meta_ct: v.string(),
        r2_key: v.string(),
        ttl_seconds: v.number(),
    })),
});
export const InboxGetResponseSchema = v.object({
    id: v.string(),
    identity_id: v.string(),
    meta_v: v.number(),
    meta_ct: v.string(),
    body: v.string(),
    received_at: TimestampSchema,
    ttl_seconds: v.number(),
    encrypted: v.boolean(),
});
//# sourceMappingURL=inbox.js.map